import { useCallback } from "react";
import { ExportButton } from "~/pages/Compliance/Common/ExportButton";
import { exportComplianceEntities } from "../exportUtil";

export type EntitiesExportButtonProps = {
  arenaId: number | null;
  clientName?: string;
};

export const EntitiesExportButton = ({ arenaId, clientName }: EntitiesExportButtonProps) => {
  const onExport = useCallback(async () => {
    if (arenaId === null) return;
    await exportComplianceEntities(arenaId, clientName ?? "--");
  }, [arenaId, clientName]);

  return (
    <ExportButton
      onExport={onExport}
      disabled={arenaId === null}
      testId="export-entities-button"
    />
  );
};
